import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    registered() {
      console.info('PWA Suite241 prête à être installée.');
    },
    error(error) {
      console.warn('Impossible d’enregistrer la PWA Suite241.', error);
    },
  });
}
